import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Check from '@material-ui/icons/Check';
import Muted from '@/components/material-ui-kit/components/Typography/Muted';
import styles from 'styles/jss/original/components/favorites/favoriteMenuModalList';
import classNames from 'classnames';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const FavoriteMenuModalList: React.FC<ComponentProps> = ({ menu }) => {
  const { title, material } = menu.fields;
  const classes = useStyles();
  const [checked, setChecked] = useState([24, 22]);

  if (material.data.length === 0) {
    return null;
  }

  const handleToggle = (value: number) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  return (
    <div className={classes.section}>
      <h5 className={classes.title}>{title}</h5>
      <hr />
      <div className={classes.attention}>
        <Muted>一人分</Muted>
      </div>
      <div className={classNames(classes.checkboxAndRadio, classes.checkboxAndRadioHorizontal)}>
        {material.data.map((item: Todo) => {
          return (
            <div key={item.material_title}>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    onClick={() => handleToggle(21)}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                }
                classes={{ label: classes.label, root: classes.labelRoot }}
                label={`${item.material_title} : ${item.material_amount}`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FavoriteMenuModalList;
